<template>
  <div>

    <data-table
      table-ref="structtable"

      :title="title"
      title-heading="h2"
      icon="fa fa-broadcast-tower"

      :url="'/struct/' + (this.siteId ? '/site/' + this.siteId : '') + (this.owner ? '/org/' + this.owner : '')"

      :fields="fields"

      :hide-top="hideTop"
      hide-org-badge

      :show-search="showSearch"
      :show-refresh="showRefresh"

      :search-placeholder="searchPlaceholder"

      :add-action="noAdd ? null : action"
      :add-props="noAdd ? null : addPropsData"

      detail-component="struct-detail-row" />

    </div>
</template>


<script>

import Vue from 'vue'

import StructControls from '@/components/tables/controls/StructControls'
import StructDetails from '@/components/tables/details/StructDetails'
import StructureAction from '@/components/actions/StructureAction'

Vue.component('struct-controls', StructControls)
Vue.component('struct-detail-row', StructDetails)

export default {

  components: {
    StructControls,
    StructureAction
  },


  props: {

    noAdd: {
      type: Boolean,
      default: false
    },

    siteId: {
      type: Number,
      default: null
    },

    owner: {
      type: Number,
      default: null
    },

    title: {
      type: String,
      default: 'Structures'
    },

    hideTop: {
      type: Boolean,
      default: false
    },

    showSearch: {
      type: Boolean,
      default: true
    },

    showRefresh: {
      type: Boolean,
      default: true
    },

    searchPlaceholder: {
      type: String,
      default: 'Name, Category, Type, Sub-Type...'

    }

  },


  data () {

    return {
      telcoId: this.isTelco() ? Number(this.org().id) : this.owner,
      action: StructureAction,

      addPropsData: {
        rowData: this.rowData,
        editMode: false
      },

      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'name',
          title: 'Structure Name',
          sortField: 'name',
          titleClass: 'hidden-md-and-up',
          dataClass: 'hidden-md-and-up'
        },
        {
          name: 'type',
          title: 'Type',
          sortField: 'type',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'subType',
          title: 'Sub-Type',
          sortField: 'subType',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'variant',
          title: 'Variant',
          sortField: 'variant',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: '__component:struct-controls',
          title: ''
        }
      ]

    }

  },  // data


  mounted () {
    if (!this.telcoId && this.isTelco()) {
      this.telcoId = Number(this.org().id)
    }

  }

}

</script>
